import { useState } from "react";

export default function CameraDeleteDialog({ run, onDelete, onClose }) {
  const [confirmation, setConfirmation] = useState("");
  const [error, setError] = useState("");
  const [deleting, setDeleting] = useState(false);
  if (!run) return null;

  const remove = async () => {
    setDeleting(true);
    setError("");
    try {
      await onDelete();
      onClose();
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-950/60 p-4" role="dialog" aria-modal="true">
      <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl">
        <h2 className="text-lg font-bold">Delete camera run</h2>
        <p className="mt-2 text-sm text-slate-600">
          Images and metadata will be removed. Active runs cannot be deleted; activate another run first.
        </p>
        <label className="mt-4 block text-sm font-semibold">
          Type <span className="font-mono">{run.run_id}</span> to confirm
          <input
            value={confirmation}
            onChange={(event) => setConfirmation(event.target.value)}
            className="mt-1 w-full rounded-xl border border-slate-200 px-3 py-2 font-mono"
          />
        </label>
        {error && <p className="mt-2 text-sm text-red-700">{error}</p>}
        <div className="mt-5 flex justify-end gap-2">
          <button onClick={onClose} className="rounded-xl px-4 py-2 text-sm font-bold text-slate-600">Cancel</button>
          <button
            onClick={remove}
            disabled={confirmation !== run.run_id || deleting}
            className="rounded-xl bg-red-700 px-4 py-2 text-sm font-bold text-white disabled:opacity-40"
          >
            {deleting ? "Deleting…" : "Delete run"}
          </button>
        </div>
      </div>
    </div>
  );
}
